import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

export type TextCardSpacing = 'default' | 'small';

@Component({
  selector: 'app-text-card',
  imports: [NgClass],
  templateUrl: './text-card.component.html',
  styleUrl: './text-card.component.css',
  standalone: true,
})
export class TextCardComponent {
  @Input() spacing: TextCardSpacing = 'default';
}
